<section class="cart">
  @if (similarProducts$ | async; as similarProducts) {
    <div class="cart__similar-product">
      @if (similarProducts.length > 0) {
        <cx-carousel
          [title]="similarProductTitle"
          [itemWidth]="carouselWidth"
          [items]="similarProducts"
          [template]="similarProductsCarousel"
          >
        </cx-carousel>
      }
      <ng-template #similarProductsCarousel let-item="item">
        <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
          <cx-media [container]="item.images" format="product"></cx-media>
          <h4>{{ item.name }}</h4>
          <div class="price">{{ item.price?.formattedValue }}</div>
        </a>
      </ng-template>
    </div>
  }
  @if (compatibleProducts$ | async; as compatibleProducts) {
    <div class="cart__compatible-product">
      @if (compatibleProducts.length > 0) {
        <cx-carousel
          [title]="compatibleProductTitle"
          [items]="compatibleProducts"
          [template]="carouselItem"
          [itemWidth]="carouselWidth"
          >
        </cx-carousel>
      }
      <ng-template #carouselItem let-item="item">
        <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
          <cx-media [container]="item.images" format="product"></cx-media>
          <h4>{{ item.name }}</h4>
          <div class="price">{{ item.price?.formattedValue }}</div>
        </a>
      </ng-template>
    </div>
  }
</section>

@if (loading) {
  <div>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </div>
}
